import { UserIntegrationItem } from 'admin/actions/integrations';
import Button from 'admin/components/common/Button';
import PopConfirm from 'admin/components/common/PopConfirm';
import Text from 'admin/components/common/Text';
import React from 'react';

type Props = {
	userIntegration: UserIntegrationItem;
	onConfirm: () => Promise<void>;
};

const RemoveUserIntegrationButton: React.FC<Props> = ({ userIntegration, onConfirm }) => {
	return (
		<PopConfirm
			title="Remove integration"
			description={<div style={{ maxWidth: 240 }}>Google integrations will be removed across all stories</div>}
			okText="Remove"
			cancelText="Cancel"
			onConfirm={onConfirm}
			okButtonProps={{ type: 'primary', danger: true, size: 'small' }}
			cancelButtonProps={{ type: 'text', size: 'small' }}
		>
			<Button
				view="label-only"
				color="danger"
				textSize={Text.size.label}
				textWeight={Text.weight.normal}
			>{`Remove "${userIntegration.label.split(' ')[0]}"`}</Button>
		</PopConfirm>
	);
};

export default RemoveUserIntegrationButton;
